exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PrivacyPages-PrivacyPages-wrapper{padding:40px 20px;background:#0376a3}.PrivacyPages-PrivacyPages-wrapperSpirotech{padding:40px 20px;background:#fae04e}.PrivacyPages-PrivacyPages-test_ul{padding-left:3em;margin-left:0;background-color:#fff;margin:0}.PrivacyPages-PrivacyPages-test_ul li{list-style-type:decimal;padding:5px}.PrivacyPages-PrivacyPages-list_characters{list-style-type:lower-alpha}.PrivacyPages-PrivacyPages-list_none{list-style-type:none}.PrivacyPages-PrivacyPages-introduce{padding:10px 20px;margin:0;background-color:#fff}", ""]);

// exports
exports.locals = {
	"wrapper": "PrivacyPages-PrivacyPages-wrapper",
	"wrapperSpirotech": "PrivacyPages-PrivacyPages-wrapperSpirotech",
	"test_ul": "PrivacyPages-PrivacyPages-test_ul",
	"list_characters": "PrivacyPages-PrivacyPages-list_characters",
	"list_none": "PrivacyPages-PrivacyPages-list_none",
	"introduce": "PrivacyPages-PrivacyPages-introduce"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-rules-2!./node_modules/postcss-loader/lib??ref--2-rules-3!./src/components/PrivacyPages/PrivacyPages.css
// module id = 1454
// module chunks = 16 17